import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteSupplierActions } from "store/ducks/settings/suppliers";

export function* deleteSupplierRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/supplier/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteSupplierActions.success(data));
    notify("success", "Fornecedor deletado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteSupplierActions.failure(errorMessage));
  }
}
